module.exports = __webpack_public_path__ + "img/chat-ai-libai.d7e8805b.svg";